export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/article_to_video.9c33427.svg";